<!--
FORM PARA ADICIONAR/ALTERAR ITEM DO PEDIDO








- retirar alteracao de item, exibir descricao do item
- ao carregar o item, formatar as opcoes da unidade de medida para digitacao, setar variavel unidades de medida
- ao digitar descontos de tabela, calcular valor total


-->

<script>
import { SysVars } from '../main';
import { getText, formatDate, formatValue } from '../shared/utils'
import { arr, calcDesconto } from '../shared/numbers'
import VarejoAddItem from '../forms-varejo/varejo-add-item'
import grade from '../components/grade'
import gradeEstoque from '../components/grade-estoque'

import Vue from 'vue';

export default {
  props: {
    params: {},
    view: Boolean,
  },

  components: {
    VarejoAddItem, grade, gradeEstoque
  },

  data() {
    return {
      errorMessage: '',
      error: false,
      pedvit: { ...this.$store.getters.getEntities.pedvit },
      metadata: this.$store.getters.getEntities.metadata,
      qtEstoque: 0,
      unWatch: false,
      showDesconto: false,
    }
  },

  computed: {
    isView: function () {
      return (this.view || (this.pedvit && this.pedvit.bloqueado == 'S'))
    },
    itemSalesList: function () {
      return this.$store.getters.getItemSalesList
    },
    coditem: function () {
      return this.pedvit.coditem
    },
    vlr: function () {
      return this.pedvit.vlr
    },
    qtuni: function () {
      return this.pedvit.qtuni
    },
    pdesc1: function () {
      return this.pedvit.pdesc1
    },
    pdesc2: function () {
      return this.pedvit.pdesc2
    },
    pdesc3: function () {
      return this.pedvit.pdesc3
    },
    pdesc4: function () {
      return this.pedvit.pdesc4
    },
    pedvit_descontotab: function () {
      return this.pedvit.descontotab
    },
    showGradeItem: function () {
      return this.pedvit.item && this.pedvit.item.isgrade == 'S'
    },
    habilitaUnimed: function () {
      return !this.showGradeItem && this.pedvit.item && this.pedvit.unimed && this.pedvit.unimed.length > 0
    },
    bloqueia_preco_item: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        return this.$store.getters.getParametrosUsuario.vendas.bloqueia_preco_item
      else
        return false
    },
    bloqueia_descontos: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        return this.$store.getters.getParametrosUsuario.vendas.bloqueia_descontos
      else
        return false
    },

  },

  methods: {
    calculaTotal() {
      //calcula o total do item ao informar quantidade, preço, descontos, etc
      let aDesc = []

      if (this.pedvit.descontotab && this.pedvit.descontotab.length > 0) {
        for (var x = 0; x < this.pedvit.descontotab.length; x++) {
          aDesc.push(this.pedvit.descontotab[x].pdesc)
        }
      }
      aDesc.push(this.pedvit.pdesc1)
      aDesc.push(this.pedvit.pdesc2)
      aDesc.push(this.pedvit.pdesc3)
      aDesc.push(this.pedvit.pdesc4)
      this.pedvit.totliq = this.pedvit.qtuni * this.pedvit.vlr
      this.pedvit.totliq = calcDesconto(this.pedvit.totliq, aDesc, 2, true)
    },

    handleSalvar() {
      this.error = false

      if (this.pedvit.qtuni <= 0) {
        this.$erpToastError('Por favor informe a quantidade do item')
        this.error = true
      }

      if (this.pedvit.vlr <= 0) {
        this.$erpToastError('Por favor informe o preço unitário do item')
        this.error = true
      }

      if (!this.error) {
        var param = []
        param.push(this.pedvit)
        this.$emit('save', param)
      }
    },

    closeForm() {
      this.$emit('closeform')
    },

    handleUpdateGrade(index, qt, listItemGrade) {
      //QUANDO FOR DIGITADA QUANTIDADE NA GRADE DO PRODUTO
      this.pedvit.qtuni = qt
      this.pedvit.pedvgrade = listItemGrade
    },

    // handleSelectItem (selectedItem) {
    //     console.log(selectedItem)
    //     //AO SELECIONAR UM ITEM NA PESQUISA, ADICIONA O ITEM NA VENDA
    //     if (!selectedItem)
    //       return
    //     this.pedvit.coditem = selectedItem.coditem
    // }

  },

  watch: {
    coditem: function () {
      this.$store.dispatch('loadItemSales', { coditem: this.coditem, codtabpre: this.params.pedv.codtabpre, codpedv: this.params.pedv.codpedv })
    },

    itemSalesList: function () {
      if (!this.itemSalesList.length) {
        return
      }
      let data = this.itemSalesList[0]
      if (data.itemlote_json) {
        data.itemlote_json = JSON.parse(data.itemlote_json)
      }

      this.pedvit.item = data

      if (this.unWatch) {
        this.unWatch = false
        return
      }

      this.pedvit.uni = this.pedvit.item.uni
      this.pedvit.vlrtab = this.pedvit.item.vlrtab
      this.pedvit.vlr = this.pedvit.item.vlrtab
      if (this.pedvit.item.tabelas_desconto)
        this.pedvit.descontotab = this.pedvit.item.tabelas_desconto.descontos
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    qtuni: function () {
      this.calculaTotal()
    },

    pdesc1: function () {
      this.calculaTotal()
    },

    pdesc2: function () {
      this.calculaTotal()
    },

    pdesc3: function () {
      this.calculaTotal()
    },

    pdesc4: function () {
      this.calculaTotal()
    },

    pedvit_descontotab: {
      handler() {
        this.calculaTotal()
      },
      deep: true
    },

    vlr: function () {
      this.calculaTotal()
    },

  },

  created() {
    //this.$store.dispatch('clearItemSales')

    this.$nextTick(function () {
      if (this.$refs.qtuni) {
        this.$refs.qtuni.focus()
      }
      // this.$refs.item.$el.querySelector('select').focus()
    })

    if (this.params.pedvit) {
      this.unWatch = true
      if (this.params.pedvit.descontotab)
        this.params.pedvit.descontotab = JSON.parse(this.params.pedvit.descontotab)
      //if (!Array.isArray(this.params.pedvit.descontotab)) {
      //    this.params.pedvit.descontotab = JSON.parse(this.params.pedvit.descontotab)
      //}
      this.pedvit = this.params.pedvit

      if ((this.pedvit.pdesc2 > 0) || (this.pedvit.pdesc3 > 0) || (this.pedvit.pdesc4 > 0)) {
        this.showDesconto = true;
      }
    }

  }

}

</script>

<template>

  <transition>
    <div id="mymodal" class="nb-modal-scrollable">
      <div class="container nb-modal-scrollable-container">
        <div class="nb-modal-header">
          <h4 class="def-title"> Item do Pedido </h4>
          <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="nb-modal-scrollable-body">
          <!-- dados do item -->
          <div class="row">
            <div class="col-md-12 col-12">
              <span class="lbl-title-produto w-100">{{ pedvit.item.descricao }}</span>
              <span class="data-list w-100">{{ pedvit.item.codigo }}</span>
              <span class="data-list"><small>{{ pedvit.item.descricao_completa }}</small></span>
              <span v-if="pedvit.vlrtab > 0" class="badge badge-yellow"><i class="fa fa-tag pr-2"></i>Preço de Tabela {{
                  pedvit.vlrtab | formatValue(2)
              }} </span>
              <span v-if="pedvit.item.desconto_tabela > 0" class="badge badge-red"><i
                  class="fa fa-tag pr-2"></i>Desconto em Tabela {{ pedvit.item.desconto_tabela | formatValue(2) }}%
              </span>
              <span class="badge badge-blue"><i class="fa fa-tag pr-2"></i>Estoque {{ pedvit.item.saldo_estoque |
                  formatValue(2)
              }}
                <a v-if="pedvit.item.itemlote_json && pedvit.item.itemlote_json.itemlotes && pedvit.item.itemlote_json.itemlotes.length > 0"
                  aria-controls="collapseExample" aria-expanded="false" data-toggle="collapse"
                  :href="`#div_itemlotes_${pedvit.item.coditem}`" role="button">
                  <i class="fa fa-caret-down ml-2" aria-hidden="true"></i>
                  Lotes
                </a>

              </span>
              <span v-if="pedvit.item.qtlotemult > 0" class="badge badge-yellow"><i class="fa fa-tag pr-2"></i>Lote
                Multiplo {{ pedvit.item.qtlotemult }} </span>

            </div>
            <!-- <div class="col-md-12 col-12">
                    <div class="form-group">
                        <label class="lbl">Item:</label>
                        <select2 v-model="pedvit.coditem"
                            v-bind:options="{}"
                            v-bind:value="pedvit.coditem"
                            v-validate="{}"
                            entity="item"
                            ref="item"
                            parent="mymodal"
                            :minlength="2">
                        </select2>
                    </div>
                </div> -->

            <!-- <div class="col-md-2 col-6">
                    <v-label :metadata-field="metadata.pedvit.vlrtab"></v-label>
                    <strong class="lbl w-100">{{ pedvit.vlrtab | formatValue(2) }}</strong>
                </div> -->
            <!-- <div class="col-md-1 col-6">
                    <v-label label="Estoque"></v-label>
                    <strong class="lbl w-100">{{ pedvit.item.saldo_estoque }}</strong>
                </div> -->
          </div>

          <div class="collapse" :id="`div_itemlotes_${pedvit.item.coditem}`" style="padding: 10px">
            <div class="row col" v-if="showGradeItem">
              <span class="lbl-title-produto mb-3">Estoque em Grade</span>
              <div class="row col">
                <grade-estoque ref="grade-estoque" :params="{ view: true, coditem: pedvit.coditem }"></grade-estoque>
              </div>
            </div>

            <span class="lbl-title-produto mb-3">Lotes de Estoque</span>
            <div
              v-if="pedvit.item.itemlote_json && pedvit.item.itemlote_json.itemlotes && pedvit.item.itemlote_json.itemlotes.length > 0">
              <div class="row align-items-center">
                <div class="col-md-2 col-2">
                  <v-label label="Depósito"></v-label>
                </div>
                <div class="col-md-2 col-2">
                  <v-label label="Lote"></v-label>
                </div>
                <div class="col-md-2 col-2">
                  <v-label label="Sublote"></v-label>
                </div>
                <div class="col-md-2 col-2">
                  <v-label label="Lote Fornecedor"></v-label>
                </div>
                <div class="col-md-2 col-2">
                  <v-label label="Validade"></v-label>
                </div>
                <div class="col-md-2 col-2">
                  <v-label label="Quantidade"></v-label>
                </div>
              </div>

              <div v-for="(itemlote, indexlote) in pedvit.item.itemlote_json.itemlotes" v-bind:key="indexlote">
                <div class="row align-items-center">
                  <div class="col-md-2 col-2">
                    <span class="data-list">{{ itemlote.coddeposito }}</span>
                  </div>
                  <div class="col-md-2 col-2">
                    <span class="data-list">{{ itemlote.lote }}</span>
                  </div>
                  <div class="col-md-2 col-2">
                    <span class="data-list">{{ itemlote.sublote }}</span>
                  </div>
                  <div class="col-md-2 col-2">
                    <span class="data-list">{{ itemlote.lotefornecedor }}</span>
                  </div>
                  <div class="col-md-2 col-2">
                    <span class="data-list">{{ itemlote.dtvalidade | formatData }}</span>
                  </div>
                  <div class="col-md-2 col-2">
                    <span class="data-list">{{ itemlote.qt }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr>

          <div class="row col" v-if="showGradeItem">
            <grade ref="grade"
              :params="{ view: isView, coditem: pedvit.coditem, qt: pedvit.qtuni, listItemGrade: pedvit.pedvgrade }"
              @update="handleUpdateGrade"></grade>
          </div>
          <div class="row">
            <form-field ref="qtuni" v-if="!showGradeItem" v-model="pedvit.qtuni" type="value" col="2"
              :metadata="metadata.pedvit.qtuni" name="qtuni" :v-errors="errors"
              v-validate="metadata.pedvit.qtuni.validator" :disabled="isView" :addon="pedvit.uni"></form-field>

            <form-field v-if="habilitaUnimed" v-model="pedvit.uni" :tabindex="-1" type="select2" col="2"
              :metadata="metadata.pedvit.uni" parent="mymodal" name="uni" :v-errors="errors"
              v-validate="metadata.pedvit.uni.validator"></form-field>

            <form-field v-if="!bloqueia_preco_item" v-model="pedvit.vlr" type="value" col="2"
              :metadata="metadata.pedvit.vlr" :disabled="isView" preaddon="R$" name="vlr" :v-errors="errors"
              v-validate="metadata.pedvit.vlr.validator"></form-field>
            <div v-else class="col-md-2 col-3">
              <v-label :metadata-field="metadata.pedvit.vlr"></v-label>
              <strong class="lbl w-100">R$ {{ pedvit.vlr | formatValue(2) }}</strong>
            </div>

            <div class="col-md-2 col-3">
              <v-label :metadata-field="metadata.pedvit.totliq"></v-label>
              <strong class="lbl w-100">R$ {{ pedvit.totliq | formatValue(2) }}</strong>
            </div>
          </div>

          <div class="row" v-if="pedvit.descontotab">
            <v-label class="col-md-12 col-12" label="Descontos de Tabela"></v-label>
            <form-field v-for="(desconto, index) in pedvit.descontotab" :key="index" :tabindex="-1"
              v-model="desconto.pdesc" type="value" col="2" :precision="2" :title="desconto.descricao" addon="%"
              :disabled="isView"></form-field>
          </div>

          <div class="row" v-if="!bloqueia_descontos">
            <v-label class="col-md-12 col-12" label="Desconto sobre desconto"></v-label>
            <form-field v-model="pedvit.pdesc1" type="value" col="2" :metadata="metadata.pedv.pdesc1" :precision="2"
              :disabled="isView" addon="%" name="pdesc1" :v-errors="errors"
              v-validate="metadata.pedvit.pdesc1.validator"></form-field>

            <!-- Desconto -->
            <div v-if="!showDesconto" class="nb-margin-top nb-margin-bottom">
              <a href="javascript:void(0);" @click="showDesconto = true"><i class="fa fa-caret-down"
                  aria-hidden="true"></i> Outros descontos</a>
            </div>
            <form-field v-model="pedvit.pdesc2" type="value" col="2" :metadata="metadata.pedv.pdesc2" :precision="2"
              :disabled="isView" addon="%" name="pdesc2" :v-errors="errors"
              v-validate="metadata.pedvit.pdesc2.validator" v-if="showDesconto"></form-field>
            <form-field v-model="pedvit.pdesc3" type="value" col="2" :metadata="metadata.pedv.pdesc3" :precision="2"
              :disabled="isView" addon="%" name="pdesc3" :v-errors="errors"
              v-validate="metadata.pedvit.pdesc3.validator" v-if="showDesconto"></form-field>
            <form-field v-model="pedvit.pdesc4" type="value" col="2" :metadata="metadata.pedv.pdesc4" :precision="2"
              :disabled="isView" addon="%" name="pdesc4" :v-errors="errors"
              v-validate="metadata.pedvit.pdesc4.validator" v-if="showDesconto"></form-field>

          </div>

          <div class="row">
            <form-field v-model="pedvit.obs" type="memo" col="6" :metadata="metadata.pedvit.obs" :disabled="isView"
              name="obs" :v-errors="errors" v-validate="metadata.pedvit.obs.validator"></form-field>
            <form-field v-model="pedvit.pedcliit" type="value" col="2" :metadata="metadata.pedvit.pedcliit"
              :disabled="isView" name="pedcliit" :v-errors="errors" v-validate="metadata.pedvit.pedcliit.validator">
            </form-field>
          </div>

          <div class="nb-modal-scrollable-footer">
            <v-button v-if="!isView" ref="btnConfirm" label="Salvar" title="" :nb-btdef="true" @click="handleSalvar">
            </v-button>
            <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
          </div>
        </div>
      </div>
    </div>
  </transition>




</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/pedido-additem.vue